// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-reset-password-form{position:relative;display:flex;flex-direction:column;padding:20px;flex:1}.login-reset-password-form form{flex:1;display:flex;flex-direction:column}.login-reset-password-form form .input-container{flex:1}.login-reset-password-form form .action-container{display:flex;align-items:center;justify-content:space-between}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
